import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { PieChart } from "react-minimal-pie-chart";
import { IoInformation } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { groupByIntoArray } from "../../../../helpers";

const colors = [
  "#50accb",
  "#4c53d6",
  "#ffcd3f",
  "#fe703f",
  "#c588dc",
  "#999999",
  "#abd9e8",
  "#afb2ed"
];

const TaskBreakdown = ({ calls, dark }) => {
  // commented out hovered, createTooltip, and onMouseOver because they were not being used. However, they are all connected (EBW)
  // const [hovered, setHovered] = useState({
  //   department: null,
  //   task: null
  // });

  const tasks = useMemo(
    () =>
      calls
        .map((call) =>
          call.tasks.map((task) => ({
            ...call.service.tasks.find((st) => st._id === task.service_task),
            department: call.service?._id,
            departmentDescription: call.service?.description,
            id: task.service_task,
            duration: task.actual_duration,
            durationUnits: task.duration_units
          }))
        )
        .filter((arr) => arr.length)
        .flat(1)
        .filter((task) => task.duration > 0),
    [calls]
  );

  const groupedDepartments = useMemo(
    () => groupByIntoArray(tasks, (task) => task.department),
    [tasks]
  );

  const groupedTasks = useMemo(
    () =>
      groupedDepartments.map((department) => {
        let dep = "";
        let departmentMinutes = 0;
        const taskList = [];
        department.forEach((group) => {
          let taskMinutes = 0;
          dep = group.departmentDescription;
          if (group.durationUnits === "Hours") {
            departmentMinutes += group.duration * 60;
            taskMinutes += group.duration * 60;
          } else {
            departmentMinutes += group.duration;
            taskMinutes += group.duration;
          }
          const index = taskList.findIndex(
            (tl) => tl.task === group.task?.description
          );
          if (index > -1) {
            taskList[index].totalSeconds += taskMinutes * 60;
          } else {
            taskList.push({
              id: group.task?.id,
              task: group.task?.description,
              totalSeconds: taskMinutes * 60,
              color: colors[taskList.length % colors.length]
            });
          }
        });
        const totalHours = Math.floor(departmentMinutes / 60);
        const totalMinutes = departmentMinutes % 60;
        const totalSeconds = totalHours * 3600 + totalMinutes * 60;
        return {
          department: dep,
          taskList,
          totalHours,
          totalMinutes,
          totalSeconds
        };
      }),
    [groupedDepartments]
  );

  // const makeTooltipContent = () => {
  //   const { department, task } = hovered;
  //   if (typeof department === "number" && typeof task === "number") {
  //     const { totalSeconds } = groupedTasks[department].taskList[task];
  //     const h = Math.floor(totalSeconds / 3600);
  //     const m = Math.floor((totalSeconds % 3600) / 60);
  //     return `${h > 0 ? `${h}h` : ""} ${m > 0 ? `${m}m` : ""}`;
  //   }
  //   return "N/A";
  // };

  return (
    <React.Fragment>
      {tasks.length > 0 &&
        groupedTasks.map((department, i) => (
          <div
            key={department.department}
            className="content-wrapper task-breakdown-container"
          >
            <div className="header-section-container">
              <h1>{`${department.department || "N/A"} Task Breakdown`}</h1>
              <div
                className="informational-tooltip-container"
                data-tooltip-variant={dark ? "dark" : "light"}
                id={`chart-${i}`}
                data-html
                data-place="right"
              >
                <span>
                  <IoInformation />
                </span>
                <ReactTooltip
                  anchorId={`chart-${i}`}
                  className={`custom-tooltip ${dark ? "dark" : "light"}`}
                  place="right"
                  type={dark ? "dark" : "light"}
                >
                  <PieChart
                    style={{ height: "200px" }}
                    lineWidth={20}
                    paddingAngle={5}
                    data={department.taskList.map((item) => ({
                      // title: makeTooltipContent(item.totalSeconds),
                      value:
                        (item.totalSeconds / department.totalSeconds) * 100,
                      color: item.color
                    }))}
                    // onMouseOver={(_, index) => {
                    //   setHovered({ department: i, task: index });
                    // }}
                    // onMouseOut={() => {
                    //   setHovered({ department: null, task: null });
                    // }}
                  />
                </ReactTooltip>
              </div>
            </div>
            <div className="task-bar-wrapper">
              <div className="task-bar-list">
                {department.taskList.map((item) => (
                  <div
                    key={`${department.department}-taskId:${item.id}`}
                    className="task-bar-container"
                  >
                    <h4>{item.task || "N/A"}</h4>
                    <div className="task-bar-breakdown">
                      <div
                        className="task-bar-legend"
                        style={{ backgroundColor: item.color }}
                      />
                      <span className="percentage">
                        {((item.totalSeconds / department.totalSeconds) * 100)
                          .toFixed(1)
                          .replace(/[.,]0$/, "")}
                        %
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  );
};

TaskBreakdown.propTypes = {
  calls: PropTypes.array,
  dark: PropTypes.bool
};

TaskBreakdown.defaultProps = {
  calls: []
};

export default TaskBreakdown;
